import Typography from '@ui/Typography';
import { cx } from 'cva';
import React from 'react';
import Reactions from './Reactions';
import useStore from '@/stores/store';
import useHasUserSession from '@/hooks/useHasUserSession';
import useConnectModalStore from '../store/connectModalSlice';
import useJoinNonProfitDialogStore from '../store/joinNonProfitDialogSlice';
import { usePathname, useRouter } from 'next/navigation';
import useNonProfitSignUpPopUpStore from '../store/nonProfitSignUpPopUpSlice';
import useCompanyConnectPopUpStore from '../store/companyConnectPopUpSlice';

function ReactionBar(props) {
  const { post, className } = props;
  const { totalReactions, latestReactionFrom, reactions, userReaction } = post;
  const showPostReactionsDialog = useStore(
    (state) => state.postContributorDialog.showDialog,
  );
  const hasUserSession = useHasUserSession();
  const router = useRouter();
  const pathname = usePathname();

  const setShowConnectModal = useConnectModalStore((state) => state.setOpen);
  const setShowJoinNonProfitModal = useJoinNonProfitDialogStore(
    (state) => state.setOpen,
  );

  const setShowNonProfitSignUpPopUp = useNonProfitSignUpPopUpStore(
    (state) => state.setOpen,
  );
  const setShowCompanyConnectPopUp = useCompanyConnectPopUpStore(
    (state) => state.setOpen,
  );

  // derived states
  const totalComments = post.totalComments || 0;

  const handleOpenForm = () => {
    if (!hasUserSession) {
      const companyId = post.renderProps.company?.id;
      const companySlug = post.renderProps.company?.slug;
      const nonProfitCompanyId = post.renderProps.nonProfit?.company_id;
      // if (
      //   (pathname.startsWith('/nonprofit') && post.renderProps.nonProfit) ||
      //   companyId === nonProfitCompanyId
      // ) {
      //   setShowJoinNonProfitModal(true, post.renderProps.nonProfit);
      // } else {
      //   setShowConnectModal(true, post.renderProps.company);
      // }
      if (
        (pathname.startsWith('/nonprofit') && post.renderProps.nonProfit) ||
        companyId === nonProfitCompanyId
      ) {
        // setShowJoinNonProfitModal(true, post.renderProps.nonProfit);
        // setShowJoinNonProfitModal(false, post.renderProps.nonProfit);
        // const returnPath = `/onboard/nonprofit-user?nonProfitId=${post.renderProps.nonProfit?.id}`;
        // router.replace(
        //   `/api/auth/signup?returnTo=${encodeURIComponent(returnPath)}`,
        // );
        setShowNonProfitSignUpPopUp(true, post.renderProps.nonProfit);
      } else if (companySlug && companySlug.includes('nonprofit/')) {
        // setShowJoinNonProfitModal(true, post.renderProps.nonProfit);
        // setShowJoinNonProfitModal(false, post.renderProps.nonProfit);
        // const returnPath = `/onboard/nonprofit-user?nonProfitId=${post.renderProps.nonProfit?.id}`;
        // router.replace(
        //   `/api/auth/signup?returnTo=${encodeURIComponent(returnPath)}`,
        // );
        setShowNonProfitSignUpPopUp(true, post.renderProps.nonProfit);
      } else {
        // setShowConnectModal(true, post.renderProps.company);
        setShowCompanyConnectPopUp(true, post.renderProps.company);
      }
    }
  };

  const handleShowAllReactions = () => {
    if (!hasUserSession) {
      handleOpenForm();
    } else if (post) {
      showPostReactionsDialog(post, null, 'reactions');
    }
  };

  const getReactingUsersText = () => {
    const reactionsFrom = [];

    if (userReaction?.hasReaction) {
      reactionsFrom.push('You');
    }

    if (latestReactionFrom) {
      reactionsFrom.push(latestReactionFrom.name);
    }

    const othersCount = totalReactions - reactionsFrom.length;

    switch (reactionsFrom.length) {
      case 0:
        if (othersCount === 1) {
          return `1 person reacted`;
        } else if (othersCount > 1) {
          return `${othersCount} people reacted`;
        }
        return '';
      case 1:
        if (othersCount === 1) {
          return `${reactionsFrom[0]} and 1 other`;
        } else if (othersCount > 1) {
          return `${reactionsFrom[0]} and ${othersCount} others`;
        }
        return `${reactionsFrom[0]} reacted`;
      case 2:
        if (othersCount === 1) {
          return `${reactionsFrom[0]}, ${reactionsFrom[1]} and 1 other`;
        } else if (othersCount > 1) {
          return `${reactionsFrom[0]}, ${reactionsFrom[1]} and ${othersCount} others`;
        }
        return `${reactionsFrom[0]} and ${reactionsFrom[1]} reacted`;
      default:
        return '';
    }
  };

  if (totalReactions > 0 || totalComments > 0) {
    return (
      <div
        className={cx(
          'flex w-full items-center justify-between py-2',
          className,
        )}>
        {totalReactions > 0 && (
          <Reactions reactions={reactions} onClick={handleShowAllReactions}>
            <Typography
              variant="body1"
              color="textSecondary"
              className="cursor-pointer hover:text-text-hyperlink">
              {getReactingUsersText()}
            </Typography>
          </Reactions>
        )}
        <div className="ml-auto flex gap-2.5">
          {post.totalComments > 0 && (
            <Typography
              onClick={handleOpenForm}
              variant="body1"
              color="textSecondary"
              className="cursor-pointer hover:text-text-hyperlink">
              {post.totalComments} comments
            </Typography>
          )}
        </div>
      </div>
    );
  }
  return null;
}

export default ReactionBar;
